
import { Link } from "react-router-dom";
import { Button } from "../Button";
import ServicesMenu from "./ServicesMenu";
import ExpertiseMenu from "./ExpertiseMenu";
import CompanyMenu from "./CompanyMenu";
const NavigationItems = () => {
  return <nav className="hidden md:flex items-center space-x-8">
      <ServicesMenu />
      
      <ExpertiseMenu />
      
      <CompanyMenu />
      
      <Link to="/schedule-consultation">
        <Button variant="glass" hasAnimation={true} className="text-base">Schedule a Consultation</Button>
      </Link>
    </nav>;
};
export default NavigationItems;
